import React from "react";
import { useParams } from "react-router-dom";
import { siteMapColorHex } from "../utils/colors";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { HazardMarkerType } from "../contexts/DataContext";
import useNavigateKeepSearchParams from "../../../hooks/useNavigateKeepSearchParams";

/**
 * TODO: how do we get out of editing mode?
  - click outside to cancel (this one could be tricky)
*/
export default function HazardMarker({
  marker,
  updateHazardMarker,
  editing,
}: {
  marker: HazardMarkerType;
  updateHazardMarker: (marker: HazardMarkerType) => void;
  editing: boolean;
}) {
  const navigate = useNavigateKeepSearchParams(["return_to"]);
  const selectedHazardId = useParams()?.hazardId;
  const hazardSelected = !!(
    selectedHazardId && marker.id === parseInt(selectedHazardId)
  );

  const color = siteMapColorHex(marker.color, "red");

  return (
    <AdvancedMarker
      key={marker.id}
      position={{ lat: marker.lat, lng: marker.lng }}
      onClick={() => {
        if (editing) {
          navigate(hazardSelected ? `.` : `edit/hazard/${marker.id}`);
        }
      }}
      onDragEnd={(e) => {
        const newLat = e.latLng?.lat();
        const newLng = e.latLng?.lng();
        if (newLat && newLng) {
          const newMarker = {
            ...marker,
            lat: newLat,
            lng: newLng,
          };
          updateHazardMarker(newMarker);
        }
      }}
      draggable={editing}
    >
      <button
        style={{
          width: editing && hazardSelected ? 45 : 30,
          height: editing && hazardSelected ? 45 : 30,
          cursor: editing ? (hazardSelected ? "grab" : "pointer") : "default",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
          fill={color}
          stroke="#fff"
          strokeWidth="30"
        >
          <path d="M160 96C160 78.3 145.7 64 128 64C110.3 64 96 78.3 96 96L96 544C96 561.7 110.3 576 128 576C145.7 576 160 561.7 160 544L160 422.4L222.7 403.6C264.6 391 309.8 394.9 348.9 414.5C391.6 435.9 441.4 438.5 486.1 421.7L523.2 407.8C535.7 403.1 544 391.2 544 377.8L544 130.1C544 107.1 519.8 92.1 499.2 102.4L487.4 108.3C442.5 130.8 389.6 130.8 344.6 108.3C308.2 90.1 266.3 86.5 227.4 98.2L160 118.4L160 96z" />
        </svg>
      </button>
    </AdvancedMarker>
  );
}
